import React, {Component} from "react";
import {Link} from "react-router";
import {FormattedDate, FormattedTime} from "react-intl";
import "./DashboardPanel.css"
import "./MocksStatusPanel.css"

class MockPanel {
    constructor(parameters = {}) {
        let {className, title, subtitle, buttonTitle, description, showUpgradeButton, buttonAdditionalClassName} = parameters;

        this.className = className;
        this.title = title;
        this.subtitle = subtitle;
        this.buttonTitle = buttonTitle;
        this.description = description;
        this.showUpgradeButton = showUpgradeButton;
        this.buttonAdditionalClassName = buttonAdditionalClassName;
    }
}

class MocksStatusPanel extends Component {
    constructor() {
        super();

        this.state = {
            mockPanel: new MockPanel({
                className: '',
                title: '',
                subtitle: '',
                buttonTitle: '',
                description: '',
                showUpgradeButton: false,
                buttonAdditionalClassName: ''
            })
        };

        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        this.updateState(this.props.status);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.status.status !== this.props.status.status) {
            this.updateState(nextProps.status);
        }
    }

    /**
     * @param mocksStatus {Object}
     */
    updateState(mocksStatus) {
        const mockPanel = new MockPanel();

        switch (mocksStatus.status) {
            case 'LOADING':
                mockPanel.className = 'panel-default';
                mockPanel.title = 'Mock Status';
                mockPanel.subtitle = 'Loading mock status';
                mockPanel.buttonTitle = 'Set up Mock';
                mockPanel.description = '';
                break;

            case 'DRAFT':
                mockPanel.className = 'panel-warning';
                mockPanel.title = 'Draft Mock';
                mockPanel.subtitle = 'Your mock is in draft mode.';
                mockPanel.buttonTitle = 'Set up Mock';
                mockPanel.description = 'Upload an OpenAPI specification to start your mock.';
                break;

            case 'UPDATING':
                mockPanel.className = 'panel-warning';
                mockPanel.title = 'Mock Updating';
                mockPanel.subtitle = 'Your mock is updating.';
                mockPanel.buttonTitle = 'Edit Mock';
                mockPanel.description = (
                    <span>
                        Your updates are being applied to your mock.
                        This may take a few minutes to complete.
                    </span>
                );
                break;

            case 'ACTIVE':
                mockPanel.className = 'panel-success';
                mockPanel.title = 'Mock Active';
                mockPanel.subtitle = 'Your mock is active and serving your APIs.';
                mockPanel.buttonTitle = 'Edit Mock';

                if (mocksStatus.lastModified) {
                    mockPanel.description = (
                        <span>
                            Mock status last updated
                            {' '}at <FormattedTime value={mocksStatus.lastModified}/>
                            {' '}on <FormattedDate value={mocksStatus.lastModified}
                                                   day="numeric"
                                                   month="long"
                                                   year="numeric"/>.
                        </span>
                    );
                } else {
                    mockPanel.description = (
                        <span>
                            Mock status last updated a while ago.
                        </span>
                    );
                }
                break;

            case 'INACTIVE':
                mockPanel.className = 'panel-warning';
                mockPanel.title = 'Mock Inactive';
                mockPanel.subtitle = 'Your mock is not running.';
                mockPanel.buttonTitle = 'Set up Mock';
                mockPanel.description = 'Upload an OpenAPI specification to start your mock.';
                break;

            case 'RETIRED':
                mockPanel.className = 'panel-warning';
                mockPanel.title = 'Mock Retired';
                mockPanel.subtitle = 'Your mock has been retired.';
                mockPanel.buttonTitle = 'Restart Mock';
                mockPanel.description = (
                    <span>
                        You're on the free subscription plan, so mocks are retired when not in use.
                        Please upgrade your plan or restart your mock.
                    </span>
                );
                mockPanel.showUpgradeButton = true;
                mockPanel.buttonAdditionalClassName = 'mock-panel-btn';
                break;

            case 'FAILED':
                mockPanel.className = 'panel-danger';
                mockPanel.title = 'Mock Error';
                mockPanel.subtitle = 'Your mock encountered an error.';
                mockPanel.buttonTitle = 'Set up Mock';
                mockPanel.description = (
                    <span>
                        Your mock failed during startup. Often this is due to invalid or incorrect configuration.
                        Please upload a valid OpenAPI file and try again.
                    </span>
                );
                break;

            default:
                mockPanel.className = 'panel-danger';
                mockPanel.title = 'Mock Status Unknown';
                mockPanel.subtitle = 'The status of your mock is unknown.';
                mockPanel.buttonTitle = 'Set up Mocks';
                mockPanel.description = '';
                break;
        }

        this.setState({mockPanel: mockPanel});
    }

    render() {
        const mockPanel = this.state.mockPanel;

        return (
            <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                <div className={`panel panel-bold ${mockPanel.className}`}>
                    <div className="panel-body dashboard-panel p-b">
                        <h3 className="m-y-0">{mockPanel.title}</h3>
                        <p>{mockPanel.subtitle}</p>
                        <hr/>

                        <div className="row">
                            <div className="col-md-7">
                                <p>{mockPanel.description}</p>
                            </div>
                            <div className="visible-xs visible-sm m-t"/>

                            <div className="col-md-5 dashboard-panel-button">
                                {mockPanel.showUpgradeButton &&
                                <Link to="/subscription"
                                      className={`btn btn-primary m-r-xs m-b-xs ${mockPanel.buttonAdditionalClassName}`}>Upgrade Plan</Link>}

                                <Link to="/mocks/config"
                                      className={`btn btn-default m-b-xs ${mockPanel.buttonAdditionalClassName}`}>{mockPanel.buttonTitle}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MocksStatusPanel.propTypes = {
    status: React.PropTypes.object
};

export default MocksStatusPanel;



// WEBPACK FOOTER //
// ./src/modules/common/MocksStatusPanel.js